import { createContext, useContext } from 'react';
import type { Draft, Gift } from './giving';

export interface GivingState {
  draft: Draft;
  draftKey: string;
  change: (gift: Gift) => Promise<void>;
  replace: (items: Gift[]) => Promise<void>;
  churchId: string | null;
  selectChurch: (id: string | null) => Promise<void>;
}
export const GivingContext = createContext<GivingState | null>(null);
export function useGiving(): GivingState {
  const value = useContext(GivingContext);
  if (!value) throw new Error('GivingProvider required');
  return value;
}
